module.exports = "<rc-app-template app-title=DSW page-title=\"Web Public Client\" nav-content=app.navContent footer-content=app.footerContent logout=false> <div class=row> <div class=\"medium-8 large-6 medium-centered column\"> <rc-alerts alerts=app.alerts ng-show=!!app.alerts.length></rc-alerts> </div> </div> <ui-view></ui-view> </rc-app-template>";


//////////////////
// WEBPACK FOOTER
// ./src/app/app.html
// module id = 26
// module chunks = 0